import { render, staticRenderFns } from "./edit-select-rate-card.vue?vue&type=template&id=123c74f4&scoped=true&"
import script from "./edit-select-rate-card.vue?vue&type=script&lang=js&"
export * from "./edit-select-rate-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c74f4",
  null
  
)

export default component.exports